import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { PAGE_SIZE } from 'core/utils/constants';
import httpclient from 'libs/Axios';
import { useEffect } from 'react';

export const useFeePaymentDuration = (list, setlist) => {
  const authData = useAuth();
  useEffect(() => {
    const request = async () => {
      // const response = await httpclient().get(`/master/feePaymentDuration/list?${PAGE_SIZE}`);
      // const data = response?.data?.data;
      // if((data?.[Object?.keys(data)?.at(0)?.toString() as string] || [])?.length) {
      //   setlist(data?.[Object?.keys(data)?.at(0)?.toString() as string] || []);
      // } else {
      //   setlist([])
      // }
      setlist(authData?.MASTER_DATA?.feePaymentDurationList || []);
    };

    request();
  }, []);
};
